import React, { useEffect, useRef, useState } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styles from './Header.module.css'
import defaultlogo from './../../../../assets/images/user-logo.png';
import logo from './../../../../assets/images/logo.png';
import ProfileIcon from '../../../../assets/images/icon/profileIcon.svg'
import userIcons from '../../../../assets/images/icon/userIcon.svg'
import jobIcon from '../../../../assets/images/icon/jobsIcon.svg'
import helpIcon from '../../../../assets/images/icon/helpIcon.svg'
import settingIcon from '../../../../assets/images/icon/settingIcon.svg'
import logoutIcon from '../../../../assets/images/icon/logoutIcon.svg'
import { getProfileImage, getStorage } from '../../../../utils'
import constant from '../../../../constant'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const DashboardHeader = () => {
  const history =  useHistory();
  const [isMobileDropDownOpen, setIsMobileDropDownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const toggleMobileDropdown = () => {
    setIsMobileDropDownOpen(!isMobileDropDownOpen);
  };
  const [isWebDropDownOpen, setIsWebDropDownOpen] = useState(false);
  const toggleWebDropdown = () => {
    setIsWebDropDownOpen(!isWebDropDownOpen);
  };
  const [data, setData] = useState(getStorage(constant.keys.userDetails) ? JSON.parse(atob(getStorage(constant.keys.userDetails))) : null);
  const [state, setState] = useState({ userType: '', profileImage: '' });
  useEffect(() => {
    getProfileImage().then(res => {
      if (res.status) {
        setState({ profileImage: res.result.fileName, userType: res.result.USER_TYPE })
      }
    })
  }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsWebDropDownOpen(false);
        setIsMobileDropDownOpen(false);

      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-md-12'>
          <nav className={`${styles['header-shadow']} navbar navbar-expand-lg mt-2 px-3`}>
            <div className={`${styles['logo-ctm']} navbar-brand logo`}>
              <Link to='/'><img src={logo} alt="logo" /></Link>
            </div>
            <button className={`${styles['dd-view']} navbar-toggler`} type='button' data-bs-toggle='collapse' data-bs-target='#navbarSupportedContent' aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
              <span className='navbar-toggler-icon'></span>
            </button>
            <div className='poistion-relative'>
              <div onClick={toggleMobileDropdown} className={`${styles['top-headerctm']}`}>
                <div className={`${styles['top-headertext']}`}>
                  <h5>{data?.COMPANY_NAME}</h5>
                  <h6>{data?.EMAIL}</h6>
                </div>
                <div>
                  <img className={`${styles['top-img']}`} src={state.profileImage ? `${process.env.REACT_APP_BASE_URL}/company/logo/${state.profileImage}` : defaultlogo} alt='usericon' />
                </div>
              </div>
              <div className={`dropdown-menu ${isMobileDropDownOpen ? "show" : ""}`}>
                <div className="menu-container">
                  <div className={`${styles['top-profilebox']} profile-section d-flex align-items-center`}>
                    <img className={`${styles['top-img']}`} src={state.profileImage ? `${process.env.REACT_APP_BASE_URL}/company/logo/${state.profileImage}` : defaultlogo} alt='usericon' />
                    <div className={`${styles['mobile-menu']} ms-2`}>
                      <h5 className="m-0">{data?.COMPANY_NAME}</h5>
                      <h6>{data?.EMAIL}</h6>
                    </div>
                  </div>
                  <ul className="menu-list list-unstyled p-0">
                    <li className={`${styles['menu-item']}`}>
                      <img className='pe-2' src={ProfileIcon} alt='usericon' />View Profile
                    </li>
                    <li className={`${styles['menu-item']}`}>
                      <img className='pe-2' src={userIcons} alt='usericon' />Edit Profile
                    </li>
                    <li className={`${styles['menu-item']}`}>
                      <img className='pe-2' src={jobIcon} alt='usericon' />Post a Job
                    </li>
                    <li className={`${styles['menu-item']}`}>
                      <img className='pe-2' src={helpIcon} alt='usericon' />Help
                    </li>
                    <li className={`${styles['menu-item']}`}>
                      <img className='pe-2' src={settingIcon} alt='usericon' />Settings
                    </li>
                    <li className={`${styles['menu-item']}`}>
                      <img className='pe-2' src={logoutIcon} alt='usericon' />Logout
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className='collapse navbar-collapse justify-content-end' id='navbarSupportedContent'>
              <div className="profile d-flex align-items-center" onClick={toggleWebDropdown}>
                <div className="profile-details text-end">
                  <strong className={`${styles['user-title']}`} style={{ display: 'block' }}>{data?.COMPANY_NAME}</strong>
                  <span className={`${styles['user-email']}`}>{data?.EMAIL}</span>
                </div>
                <img className={`${styles['user-icon']} ms-2`} src={state.profileImage ? `${process.env.REACT_APP_BASE_URL}/company/logo/${state.profileImage}` : defaultlogo} alt='user' />
              </div>
            </div>
            <div className={`dropdown-menu ${styles['ctmdropdown-menu']} ${isWebDropDownOpen ? "show" : ""}`}>
              <div className="menu-container">
                <div className={`${styles['top-profilebox']} profile-section d-flex align-items-center`}>
                  <img className={`${styles['top-img']}`} src={state.profileImage ? `${process.env.REACT_APP_BASE_URL}/company/logo/${state.profileImage}` : defaultlogo} alt='usericon' />
                  <div className={`${styles['mobile-menu']} ms-2`}>
                    <h5 className="m-0">{data?.COMPANY_NAME}</h5>
                    <h6>{data?.EMAIL}</h6>
                  </div>
                </div>
                <ul className="menu-list list-unstyled p-0">
                  <li className={`${styles['menu-item']}`}>
                    <img className='pe-2' src={ProfileIcon} alt='usericon' />View Profile
                  </li>
                  <li className={`${styles['menu-item']}`}>
                    <img className='pe-2' src={userIcons} alt='usericon' />Edit Profile
                  </li>
                  <li className={`${styles['menu-item']}`}>
                    <img className='pe-2' src={jobIcon} alt='usericon' />Post a Job
                  </li>
                  <li className={`${styles['menu-item']}`}>
                    <img className='pe-2' src={helpIcon} alt='usericon' />Help
                  </li>
                  <li className={`${styles['menu-item']}`}>
                    <img className='pe-2' src={settingIcon} alt='usericon' />Settings
                  </li>
                  <li className={`${styles['menu-item']}`}>
                    <img className='pe-2' src={logoutIcon} alt='usericon' />Logout
                  </li>
                </ul>
              </div>
            </div> */}
            <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
              {/* Profile Toggle Button */}
              <div
                className="profile d-flex align-items-center position-relative"
                role="button"
                aria-expanded={isWebDropDownOpen}
                // onClick={toggleWebDropdown}
                // ref={dropdownRef}
                onClick={()=>{
                  history.push(constant.component.viewProfile.url)
                }}
              >
                <div className="profile-details text-end">
                  <strong className={`${styles["user-title"]}`} style={{ display: "block" }}>
                    {data?.COMPANY_NAME || "Company Name"}
                  </strong>
                  <span className={`${styles["user-email"]}`}>{data?.EMAIL || "email@example.com"}</span>
                </div>
                <img
                  className={`${styles["user-icon"]} ms-2`}
                  src={state.profileImage ? `${process.env.REACT_APP_BASE_URL}/company/logo/${state.profileImage}` : defaultlogo}
                  alt="user"
                />
              </div>

              {/* Dropdown Menu Positioned Below */}
              {/* <div
                className={`dropdown-menu ${styles["ctmdropdown-menu"]} ${isWebDropDownOpen ? "show" : ""}`}
                style={{
                  position: "absolute",
                  top: "100%",  // Places it right below the profile button
                  right: "0",     // Aligns it with the profile button
                  width: "250px", // Adjust width as needed
                  zIndex: "1000", // Ensures it appears above other elements
                }}
              >
                <div className="menu-container">
                  <div className={`${styles["top-profilebox"]} profile-section d-flex align-items-center`}>
                    <img
                      className={`${styles["top-img"]}`}
                      src={state.profileImage ? `${process.env.REACT_APP_BASE_URL}/company/logo/${state.profileImage}` : defaultlogo}
                      alt="usericon"
                    />
                    <div className={`${styles["mobile-menu"]} ms-2`}>
                      <h5 className="m-0">{data?.COMPANY_NAME || "Company Name"}</h5>
                      <h6>{data?.EMAIL || "email@example.com"}</h6>
                    </div>
                  </div>
                  <ul className="menu-list list-unstyled p-0">
                    <li className={`${styles["menu-item"]}`}>
                      <img className="pe-2" src={ProfileIcon} alt="usericon" /> View Profile
                    </li>
                    <li className={`${styles["menu-item"]}`}>
                      <img className="pe-2" src={userIcons} alt="usericon" /> Edit Profile
                    </li>
                    <li className={`${styles["menu-item"]}`}>
                      <img className="pe-2" src={jobIcon} alt="usericon" /> Post a Job
                    </li>
                    <li className={`${styles["menu-item"]}`}>
                      <img className="pe-2" src={helpIcon} alt="usericon" /> Help
                    </li>
                    <li className={`${styles["menu-item"]}`}>
                      <img className="pe-2" src={settingIcon} alt="usericon" /> Settings
                    </li>
                    <li className={`${styles["menu-item"]}`}>
                      <img className="pe-2" src={logoutIcon} alt="usericon" /> Logout
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>

          </nav>
        </div>
      </div>
    </div>
  )
}

export default DashboardHeader